import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react"
import { FileRejection, useDropzone } from 'react-dropzone';
import { toast } from "react-toastify";
import type { FileProps, ImageBase64Props } from "~/components/ImportFileField";
import { useLang } from "~/hooks/useLang";
import filesize from "filesize";
import { EntryImportFileFieldList } from "~/components/ImportFileFieldList";
import type { StateMethods } from "@hookstate/core";

interface UploadImageButtonProps { 
  readonly fileMediaDevice?: StateMethods<string | null>
}



export default function UploadImageButton({ fileMediaDevice }: UploadImageButtonProps) {
  const { translate } = useLang();
  const [imageBase64, setImageBase64] = useState<ImageBase64Props>();
  const [uploadedFiles, setUploadedFiles] = useState<FileProps>();
  const [isLoading, setIsLoading] = useState(false);
  const maxSize = 16000000;


  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'image/jpeg': [],
      'image/png': [],
      'image/jpg': [],
    },
    maxFiles: 1,
    onDropAccepted: submitFile,
    onDropRejected: rejectFiles,
    multiple: false,
    maxSize
  });

  function submitFile(files: readonly File[]) {
    const file = files[0]
    const reader = new FileReader();
    reader.readAsDataURL(file)
    reader.addEventListener('loadend', () => {
      setImageBase64({ file, image: reader.result });
    })
  }

  useEffect(() => {
    if (imageBase64) {
      const image = imageBase64.image as string
      setUploadedFiles({
        file: imageBase64.file,
        image: image,
        name: imageBase64.file.name,
        readableSize: filesize(imageBase64.file.size),
        type: imageBase64.file.type.split('/')[1]
      })
      fileMediaDevice?.set(image)
    }

  }, [imageBase64])

  async function handleUpload(): Promise<void> {
    if (!uploadedFiles) return;
    const { image, type, name } = uploadedFiles;

    setIsLoading(true)
    // await sendFile({ dispatchId, type, image, name })
    setIsLoading(false)
    // handleClickImport()
  }

  function rejectFiles(fileRejections: readonly FileRejection[]) {

    fileRejections.forEach(fileRejection => {
      fileRejection.errors.forEach(err => {
        if (err.code === 'file-invalid-type') {
          toast.error(translate('Enter a file of the following types:') + 'jpg, jpeg, png')
          return
        } else if (err.code === 'file-too-large') {
          toast.error(translate('File is larger than') + ` ${maxSize / 1000000}MB`)
          return
        }
      })
    })

  }

  return (
    <section className="container" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
      <div {...getRootProps({ className: 'dropzone' })} style={{ width: '50%' }}>
        <input {...getInputProps()} />
        <p>
          {translate('Drag and Drop Image Here')}
        </p>
      </div>
      <div style={{ width: '50%' }}>
        <aside>
          {!!uploadedFiles && <EntryImportFileFieldList file={uploadedFiles} />}
        </aside>
      </div>
      <footer>
        <Grid container direction="row"
          justifyContent="center"
          alignItems="center"
        >
          {/* <Grid item p={2}>

            <LoadingButton
              onClick={handleUpload}
              loading={isLoading}
              loadingPosition="end"
              variant="contained"
              size='small'
            >
              {translate('Save')}
            </LoadingButton>

          </Grid> */}
          {/* <Fab
            size="small"
            // onClick={handleClickImport}
            sx={{
              position: 'absolute',
              top: '-15px',
              right: '-2px',
              transform: 'scale(0.6)',
              color: '#black',
              backgroundColor: '#9e9e9e',
              "&:hover": { backgroundColor: "#6e6e6e" }
            }}
          >
            <ClearIcon />
          </Fab > */}
        </Grid>
      </footer>

    </section>
  )
}